import { render, staticRenderFns } from "./addVehicleType.vue?vue&type=template&id=2d326946&scoped=true&"
import script from "./addVehicleType.vue?vue&type=script&lang=js&"
export * from "./addVehicleType.vue?vue&type=script&lang=js&"
import style0 from "./addVehicleType.vue?vue&type=style&index=0&id=2d326946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d326946",
  null
  
)

export default component.exports